




































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { UserTypes } from '@/enums/userTypes';
import { AttachmentFile } from '@/models/attachmentFile';

@Component
export default class ChatBalloon extends Vue {
  private UserTypes = UserTypes;

  @Prop() private name: string;
  @Prop() private userType: number;
  @Prop() private message: string;
  @Prop() private read: boolean;
  @Prop() private fileList: AttachmentFile[];
  @Prop({ type: [Date] }) private date: Date;
  @Prop() private deletable: boolean;

  private fileListModel = new Array<AttachmentFile>();

  private uploadFilePreview = {
    visible: false,
    title: '',
    filePath: '',
    fileRaw: {},
  };

  get dispMessage() {
    if (!this.message) {
      return '';
    }
    const reg = new RegExp(/(https?(:\/\/[-_.!~*\'()a-zA-Z0-9;\/?:\@&=+\$,%#]+))/g);
    const value = this.message.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    return '<pre>' + value.replace(reg, '</pre><a href="$1" target="_blank">$1</a><pre>') + '</pre>';
  }

  @Watch('fileList')
  private changeFileList() {
    this.loadData();
  }

  private created() {
    this.loadData();
  }

  private loadData() {
    if (!this.fileList) {
      return;
    }

    this.fileListModel = JSON.parse(JSON.stringify(this.fileList));

    if (!!this.fileListModel) {
      this.fileListModel.map(async (file) => {
        await this.$store.dispatch('file/setAttachmentFileInfo', file);
        const index = this.fileListModel.findIndex((item) => item === file);
        if (index >= 0) {
          this.fileListModel.splice(index, 1, file);
        }
      });
    }
  }

  private onClickImage(file: AttachmentFile) {
    if (!!file.localUrl) {
      if (!!file.raw && /^image\//.test(file.raw.type)) {
        this.uploadFilePreview.title = file.name;
        this.uploadFilePreview.filePath = file.localUrl;
        this.uploadFilePreview.fileRaw = file.raw;
        this.uploadFilePreview.visible = true;
      } else {
        const fileName = file.name;
        if (!(window.navigator as any).msSaveOrOpenBlob) {
          const link = document.createElement('a');
          link.href = file.localUrl as string;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else if (!!file.raw) {
          const url = (window.navigator as any).msSaveOrOpenBlob(file.raw, fileName);
        }
      }
    }
  }

  private onDelete() {
    this.$emit('delete');
  }
}
